'use client'

import { storyblokEditable } from '@storyblok/react/rsc'
import { type FC } from 'react'

import {
  AD_BANNER_CATEGORY_WIDE,
  AD_BANNER_CATEGORY_WIDE_DIMENSIONS,
  AdServerBanner,
} from '../../../ad-server'
import { useDeviceDetectorContext } from '../../../device-detector'
import { type StoryblokComponentProps } from '../../model'
import { type StoryblokCategoryAdBannerWideType } from '../../storyblok'

export const StoryblokCategoryAdBannerWide: FC<
  StoryblokComponentProps<StoryblokCategoryAdBannerWideType>
> = ({ blok }) => {
  const { isMobile } = useDeviceDetectorContext()

  return (
    <AdServerBanner
      {...storyblokEditable(blok)}
      bannerTags={[AD_BANNER_CATEGORY_WIDE]}
      className="justify-center"
      dimensions={
        isMobile
          ? AD_BANNER_CATEGORY_WIDE_DIMENSIONS.SMALL
          : AD_BANNER_CATEGORY_WIDE_DIMENSIONS.LARGE
      }
      showSkeleton
    />
  )
}
